import React from 'react';
import Spinner from './Spinner';

export default function StatsCard({ title, value, subtitle, icon, color = 'accent', trend, loading = false }) {
  const colors = {
    accent: 'bg-accent/10 text-accent',
    teal:   'bg-teal/10 text-teal',
    gold:   'bg-gold/10 text-gold',
    danger: 'bg-danger/10 text-danger',
    muted:  'bg-white/[0.06] text-text-muted',
  };

  return (
    <div className="card-padded flex items-start justify-between gap-4">
      <div className="flex-1 min-w-0">
        <p className="text-xs text-text-muted font-medium uppercase tracking-wider mb-2">{title}</p>
        {loading ? (
          <Spinner size="sm" />
        ) : (
          <p className="text-2xl font-bold text-text-main">{value ?? '—'}</p>
        )}
        {subtitle && <p className="text-xs text-text-muted mt-1">{subtitle}</p>}
        {trend !== undefined && !loading && (
          <p className={`text-xs mt-1 ${trend >= 0 ? 'text-teal' : 'text-danger'}`}>
            {trend >= 0 ? '▲' : '▼'} {Math.abs(trend)}% vs last month
          </p>
        )}
      </div>
      {icon && (
        <div className={`p-3 rounded-xl flex-shrink-0 ${colors[color] ?? colors.accent}`}>
          {icon}
        </div>
      )}
    </div>
  );
}
